<script setup lang="ts">
import { ProductCardSkeleton } from '@laam/ui/base';
</script>
<template>
	<div
		class="product_list_container_skeleton lg:grid-cols-4 p-3xl gap-3xl grid grid-cols-2"
	>
		<template v-for="i in 10" :key="i">
			<ProductCardSkeleton />
		</template>
	</div>
</template>
